import { MenuItem, Select } from "@mui/material";

export function CustomSelectDropdown(props) {
  const { options, value, onChange } = props;

  const handleValueChange = (e: any) => {
    const { value } = e?.target;

    if (onChange) {
      const syntheticEvent = {
        target: {
          value,
        },
      } as React.ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <Select size="small" value={value} onChange={handleValueChange}>
      {options?.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value.toString()}
          disabled={option.disabled}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
